import Constant from "@constant/index.js";
import API from "@api/index.js";
import {$util} from "@util/util.js";

export default {
    doActiveAction(params){
        return new Promise((resolve, reject)=>{
            API.setActive(params).then(x=>{
                resolve(x.t);
            }).catch(err=>{
                reject(err.msg);
            })
        })
    },
    doRemoveAction(params){
        return new Promise((resolve, reject)=>{
            API.removeItem(params).then(x=>{
                resolve(x.t);
            }).catch(err=>{
                reject(err.msg);
            })
        })
    },
    doModifyCount(params){
        return new Promise((resolve, reject)=>{
            API.modifyCount(params).then(x=>{
                resolve(x.t);
            }).catch(err=>{
                reject(err.msg);
            })
        })
    },
    setActive(options){
        let model = options.model;
        let itemIds = options.itemIds;
        let checkStatus = !model._isChecked;
        let params = {
            itemId:"",
            active:checkStatus,
            terminal:_terminal,
            shopId:_shopId
        }
        //如果不是批量操作 (全选操作)
        if(!itemIds){
            if(model._invalid || model._purchaseEnable == false){
                return Promise.reject(Constant.MSG.SKU_INVALID);
            }
            params.itemId = model._itemId;
        }else{
            params.itemId = itemIds;
            params.active = !model?.checkedAll; // 如果是全选操作，则直接全选状态值取反 20230606接口新增checkedAll字段标识是否为全选
        }
        return this.doActiveAction(params);
    },
    setActiveOne(options){
        let model = options.model;
        let itemIds = options.itemIds;
        let checkStatus = model._isChecked;
        let params = {
            itemId:"",
            active:checkStatus,
            terminal:_terminal,
            shopId:_shopId
        }
        //如果不是批量操作
        if(!itemIds){
            if(model._invalid || model._purchaseEnable == false){
                return Promise.reject(Constant.MSG.SKU_INVALID);
            }
            params.itemId = model._itemId;
        }else{
            params.itemId = itemIds;
            params.active = !model?.checkedAll; // 如果是全选操作，则直接全选状态值取反 20230606接口新增checkedAll字段标识是否为全选
        }
        return this.doActiveAction(params);
    },
    removeAction(options){
        let model = options.model;
        let itemIds = options.itemIds;
        let sid = options.servicesId;
        let params = {
            itemIds:"",
            terminal:_terminal,
            shopId:_shopId
        }
        if(sid){
            params.service = sid;
        }
        if(!itemIds){
            params.itemIds = model._itemId;
        }else{
            params.itemIds = itemIds;
        }
        return this.doRemoveAction(params);
    },
    addFavorite(ids){
        let params = {
            gcode: ids,
            plat:_terminal
        }
        // return API.addFavorite(params);
        return $util.doLoginAction().then(()=>{
            return API.addFavorite(params);
        }).catch(err=>{
            return Promise.reject(err.msg);
        })
    },
    modifyCount(options){
        let model = options.model;
        let count = options.count;
        let optionId = options.optionId;
        let params = null;
        if(optionId){
            params = {
                itemId:model._itemId,
                terminal:_terminal,
                shopId:_shopId,
                optionCount:count,
                optionId:optionId,
                modifyOption:true
            }
        }else{
            params = {
                itemId:model._itemId,
                terminal:_terminal,
                shopId:_shopId,
                icount:count
            }
        }
        return this.doModifyCount(params);
    },
    modifyItemFromCart(options){
        let model = options.model;
        let opsType = options.opsType;     
        let content = options.content;   
        let params = {
            itemId:model._itemId,
            terminal:_terminal,
            shopId:_shopId,
            opsType:opsType            
        }
        if(opsType == 1){
            params.options = content;
        }
        if(opsType == 2){
            params.gifts = content;
        }
        if(opsType == 3){
            params.services = content;
        }
        if(opsType == 4){
            params.personalization = content;
        }
    
        return new Promise((resolve, reject)=>{
            API.modifyItemFromCart(params).then(x=>{
                resolve(x.t);
            }).catch(err=>{
                reject(err.msg);
            })
        })
    }
}